import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.regexp.match.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.regexp.to-string.js";
import "core-js/modules/es6.regexp.constructor.js";
import "core-js/modules/es6.array.slice.js";
import moment from 'moment';
import String from '@/services/String';
export default (function (_ref) {
  var Vue = _ref.Vue;
  // display date time
  Vue.filter('displayDbDateTime', function (value) {
    if (value) {
      var td = moment(value, 'YYYY-MM-DD HH:mm:ss');
      return td.format('DD/MM/YYYY HH:mm:ss');
    }
    return '';
  });
  // display initials
  Vue.filter('initials', function (value) {
    if (value) {
      var matches = value.match(/\b(\w)/g);
      return matches.join('').toUpperCase();
    }
    return '';
  });
  // format party
  Vue.filter('formatparty', function (gn, fn, bo, jh) {
    if (!gn) {
      gn = '';
    }
    // check if company
    // eslint-disable-next-line
    if (parseInt(gn.replace(/ /g, ''))) {
      var _name = "".concat(fn, " ACN ").concat(String.formatACN(gn));
      if (bo && bo !== '') {
        _name += " ATF ".concat(bo);
      }
      return _name;
    }
    var name = "".concat(gn, " ").concat(fn);
    if (bo && bo !== -'') {
      name += " ATF ".concat(bo.replace('ATF', ''));
    }
    if (jh && jh !== '') {
      name += " & ".concat(jh);
    }
    return name;
  });
  Vue.filter('currency', function (value) {
    if (typeof value !== 'number') {
      value = parseFloat(value);
    }
    var formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    });
    return formatter.format(value);
  });
  Vue.filter('highlight', function (str, terms) {
    if (terms) {
      str = str.toString();
      var allTermsRegexStr;
      if (typeof terms === 'string') {
        allTermsRegexStr = terms;
      } else {
        // Sort array by length then  join with regex pipe separator
        allTermsRegexStr = terms.sort(function (a, b) {
          return b.length - a.length;
        }).join('|');
      }
      // eslint-disable-next-line
      allTermsRegexStr = allTermsRegexStr.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');

      // Regex to simultaneously replace terms - case insensitive!
      var regex = new RegExp("(".concat(allTermsRegexStr, ")"), 'ig');
      return str.replace(regex, '<span class="text-warning">$&</span>');
    }
    return str;
  });
  Vue.filter('nl2br', function (str) {
    if (typeof str === 'undefined' || str === null) {
      return '';
    }
    var breakTag = '<br />';
    // eslint-disable-next-line
    return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
  });
  Vue.filter('yesno', function (str) {
    if (typeof str === 'undefined' || str === null) {
      return 'No';
    }
    if (str === 1 || str === 'True') {
      return 'Yes';
    }
    return 'No';
  });
  Vue.filter('capitalize', function (val) {
    return val.replace(/\w+/g, function (a) {
      return a.charAt(0).toUpperCase() + a.slice(1).toLowerCase();
    });
  });
});